<template>
	<div class="block">
		<!--走马灯开始-->
		<el-carousel height="590px" @change="changeItem" indicator-position="none" arrow="never" ref="carousel">
			<el-carousel-item v-for="(item, index) in msgs" :key="index" class="animated fadeIn">
				<a :href="item.jumpUrl" class="link_item">
					<el-image :src="item.imageUrl">
						<div slot="placeholder" class="image-slot">
							<img src="" width="100%" height="590" alt="" />
							<!-- <img src="~@/assets/image/banner_kong.png" width="100%" height="590" alt="" /> -->
						</div>
						<div slot="error" class="image-slot">
							<img src="" width="100%" height="590" alt="" />
							<!-- <img src="~@/assets/image/banner_kong.png" width="100%" height="590" alt="" /> -->
						</div>
					</el-image>
				</a>
			</el-carousel-item>

		</el-carousel>
		<!--走马灯开始-->
		<!--动态消息开始-->
		<section class="dynamicCon clearfix   rotate" :class="{on:canRotate}">

			<img src="~@/assets/image/news.gif" alt="" class="newIcon" v-show="vShow" width="28" height="28">

			<slot name="titleTxt">
				<el-carousel height="78px" direction="vertical" :interval="5000">
					<el-carousel-item v-for="(item, index) in dynamicnews" :key="index">
						<h3 class="small" @click="goNewDetail(item.id)">{{ item.title }}</h3>
					</el-carousel-item>
				</el-carousel>
			</slot>
			<div class="dot">
				<span :class="{'on': index==caroulelIndex}" v-for="(item,index) in msgs" :key=index @click="setActiveItem(index)"></span>
			</div>


		</section>
		<!--动态消息结束-->
	</div>



</template>

<script>
	import {
		getBannerList,
		GetsDynamicList
	} from '../views/Home/Home.model'
	export default {
		name: "Carousel",
		props: {
			isShow: Boolean
		},
		data() {
			return {
				caroulelIndex: 0,
				msgs: [],
				dynamicnews: [],
				vShow: false,
				canRotate: false
			}
		},
		async mounted() {
			setTimeout(() => {
				this.canRotate = true;
			}, 1000);
			this.vShow = this.isShow;
			let param = {
				page: 1,
				limit: 6
			};
			const bannerList = await getBannerList();
			this.msgs = bannerList.data.list;
			const news = await GetsDynamicList(param);

			this.dynamicnews = news.data.list;
		},
		methods: {
			setActiveItem: function(index) {
				this.$refs.carousel.setActiveItem(index);
			},
			changeItem: function(index) {
				this.caroulelIndex = index
			},
			goNewDetail(newId) {
				this.$router.push({
					path: '/NewDetail',
					query: {
						plan: newId
					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.link_item {
		width: 100%;
		height: 100%;
		display: block;
		cursor: pointer;
	}

	.el-image {
		width: 100%;
		height: 100% !important;

		img {
			height: 100%;
			display: block;
		}
	}

	.block {
		position: relative;
	}

	.el-carousel__item {
		background-color: #D7D7D7;
		overflow: hidden;
		line-height: 580px;
		color: #fff;
		font-size: 35px;
		overflow: hidden;

		img {
			display: block;
			height: 100%;
		}
	}

	.el-carousel__indicators--outside {
		position: fixed !important;
		z-index: 9;
	}

	.dynamicCon {
		z-index: 999999 !important;
		width: 1240px;
		background-color: #fff;
		height: 80px;
		position: absolute;
		left: 50%;
		margin-left: -620px;
		top: 550px;
		z-index: 9;
		box-shadow: 0px 3px 7px 1px rgba(0, 0, 0, 0.1);
		padding-left: 40px;
		box-sizing: border-box;

		.el-carousel {
			width: 600px;
			/*.el-image{*/
			/*width: 100%;*/
			/*height: 100%!important;*/
			/*border:1px solid green;*/
			/*img{*/
			/*height: 100%;*/
			/*display:block;*/
			/*border:1px solid green;*/
			/*}*/
			/*}*/
		}

		.newIcon {
			float: left;
			margin-top: 26px;
			margin-right: 10px;
		}

		.el-carousel__item {
			background-color: #fff;
			float: left;
			color: #999;
			font-size: 14px;
			line-height: 80px;
			text-align: left;
		}

		.small {
			max-width: 500px;
			cursor: pointer;
		}
	}

	.title-txt {
		color: red;
		text-align: left;
	}



	.dot {
		position: absolute;
		top: 50%;
		margin-top: -5px;
		right: 24px;

		span {
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background-color: #E6E6E6;
			margin-left: 5px;
			float: left;
			display: block;
			z-index: 99999999999999999999999;
		}

		span.on {
			background-color: #39B2EC;
		}
	}

	.el-image__inner {
		height: 100%;
	}

	.rotate {
		transition: all .5s;
		-webkit-transition: all .5s;
		/* Safari */
	}

	.rotate.on {
		transform: rotateX(360deg);
		-webkit-transform: rotateX(360deg);
		/* Safari and Chrome */
		-moz-transform: rotateX(360deg);
		/* Firefox */
		-ms-transform: rotateX(360deg);
		transition: transform 1.5s;
		-moz-transition: transform 1.5s;
		/* Firefox 4 */
		-webkit-transition: transform 1.5s;
		/* Safari 和 Chrome */
		-o-transition: transform 1.5s;
		/* Opera */
	}

</style>
